import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

const getFilteredFields = (
  fieldModel: IFieldModel,
  filters: Partial<FilterModel>,
  hiddenFields?: IField[]
) => {
  const hiddenFieldNames = new Set(hiddenFields ? hiddenFields.map(({ name }) => name) : []);
  const allowedFieldByFilterName = new Map(
    fieldModel.fields
      .filter(({ name }) => !hiddenFieldNames.has(name))
      .map((field) => [field.filterName, field])
  );
  return Object.keys(filters)
    .filter((fieldFilterName) => isDefined((filters as Partial<FilterModel>)[fieldFilterName]))
    .map((fieldFilterName) => allowedFieldByFilterName.get(fieldFilterName))
    .filter(isDefined);
};

export default getFilteredFields;
